import React, { useState, useMemo } from "react";
import { getCategory, extractTags } from "../../utils/blogUtils";

const BlogSidebar = ({ blogs = [], setFilteredBlogs = () => { } }) => {

    const [search, setSearch] = useState("");

    // safe array
    const safeBlogs = useMemo(() => {
        return Array.isArray(blogs) ? blogs : [];
    }, [blogs]);
    // Categories
    const categories = useMemo(() => {
        return [...new Set(safeBlogs.map(b => getCategory(b.title)))];
    }, [safeBlogs]);

    // Tags
    const tags = useMemo(() => {
        return [...new Set(safeBlogs.flatMap(b => extractTags(b.content)))];
    }, [safeBlogs]);

    // SEARCH
    const handleSearch = (e) => {
        e.preventDefault();

        const result = safeBlogs.filter(b =>
            b.title.toLowerCase().includes(search.toLowerCase()) ||
            b.content.toLowerCase().includes(search.toLowerCase())
        );

        setFilteredBlogs(result);
    };

    // CATEGORY FILTER
    const handleCategory = (cat) => {
        setFilteredBlogs(
            safeBlogs.filter(b => getCategory(b.title) === cat)
        );
    };

    // TAG FILTER
    const handleTag = (tag) => {
        setFilteredBlogs(
            safeBlogs.filter(b => extractTags(b.content).includes(tag))
        );
    };

    return (
        <div className="blog-sidebar">

            {/* SEARCH */}
            <div className="widget search-widget">
                <h3>Search</h3>
                <form onSubmit={handleSearch}>
                    <input
                        type="text"
                        placeholder="Search blog..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </form>
            </div>

            {/* CATEGORY */}
            <div className="widget category-widget">
                <h3>Categories</h3>
                <ul>
                    {categories.map((cat, i) => (
                        <li key={i}>
                            <button onClick={() => handleCategory(cat)}>
                                {cat}
                                <span>
                                    {safeBlogs.filter(b => getCategory(b.title) === cat).length}
                                </span>
                            </button>
                        </li>
                    ))}
                </ul>
            </div>

            {/* TAGS */}
            <div className="widget tag-widget">
                <h3>Popular Tags</h3>
                <ul>
                    {tags.map((tag, i) => (
                        <li key={i}>
                            <button onClick={() => handleTag(tag)}>
                                {tag}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>

        </div>
    );
};

export default BlogSidebar;
